export default __webpack_public_path__ + "static/media/profile-time.95cba19d.svg";